import { RouteConfig } from 'vue-router';

import { templateNameRoute } from './steps/name.route';

export function templateManageRoute(
  path: string,
  name: string,
  title: string,
  steps: any[],
  children: RouteConfig[] = []
): RouteConfig {
  children = [templateNameRoute(name), ...children];
  return {
    path,
    name,
    children,
    component: () => import(/* webpackChunkName: "TemplateManage" */ '@/views/mainRoute/template/Manage.vue'),
    meta: { breadcrumb: { title } },
    redirect: { name: name + 'Name' },
    props: { title, steps }
  };
}
